var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.badge)?_c('lx-status-badge',_vm._b({staticClass:"root gig-job-status-badge"},'lx-status-badge',_vm.badge,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }